import { useState, useRef, useEffect, useMemo, useCallback } from "react";
import * as PR from "../../../prime-react/index";
import "../AlertTags/AlertTags.scss";
import { getAlertsCount } from "../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { analystChartTitles } from "../../../utils/reuse";
import { download, generateCsv, mkConfig } from "export-to-csv";
import { useNavigate } from "react-router-dom";
import { inputSearchHandler } from "../../../utils/inputValidate";
const SuspiciousReport = ({ alertId, isDetailScreen, exportVisible, setExportModalHandler, getDataHandler, getResponseHandler }) => {
    const graphType = 'srpa';
    const menuRight = useRef(null);
    const [alertID, setAlertID] = useState(alertId ?? '');
    const [searchAlertId, setSearchAlertId] = useState(alertId ?? '');
    const [loading, setLoading] = useState(false);
    const [suspiciousBetting, setSuspiciousBetting] = useState([]);
    const sessionData = useSelector((state) => state.auth.sessionData);
    const headers = useMemo(() => { return { sessionid: sessionData.sessionId, }; }, [sessionData.sessionId]);
    const isExport = useSelector(state => state.auth?.exportPermission);
    const [error, setError] = useState('');
    const [noRecordsFound, setNoRecordsFound] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchData = useCallback((id) => {
        setLoading(true);
        const obj = {
            type: graphType,
            alertID: id,
        };
        getAlertsCount(obj, headers, dispatch, (response) => {
            setLoading(false);
            if (response.result === 'SUCCESS') {
                const responseData = response.data;
                let reportsSentPerReceiver = responseData?.['suspiciousReportsPerAlert'];
                setSuspiciousBetting(reportsSentPerReceiver);
                setNoRecordsFound(alertID && !reportsSentPerReceiver);
                setError('');
            } else {
                setNoRecordsFound(false);
                setSuspiciousBetting([]);
                setError('Alert ID not found');
            }
            setTimeout(() => {
                setError('');
                setNoRecordsFound(false)
            }, 3000);
        });
    }, [headers, dispatch, alertID]);
    useEffect(() => {
        if (getResponseHandler) {
            getResponseHandler(suspiciousBetting); // pass the data to details screen
        }
    }, [getResponseHandler, suspiciousBetting]);
    useEffect(() => {
        if (isDetailScreen && noRecordsFound) {
            getDataHandler('No results found', 'records');
        } else if (isDetailScreen && error) {
            getDataHandler('Alert ID not found');
        }
    }, [error, getDataHandler, isDetailScreen, noRecordsFound]);
    useEffect(() => {
        const id = isDetailScreen ? alertId : alertID;
        if (id) {
            fetchData(id);
        }
    }, [alertID, alertId, fetchData, isDetailScreen]);
  
    const searchHandler = e => {
        e?.preventDefault()
        if (!searchAlertId) return;
        let alertID = searchAlertId;
        if (!searchAlertId.toLowerCase().startsWith('alert-')) {
            alertID = `alert-${searchAlertId}`
        }
        setAlertID(alertID)
    }
    const downloadHandler = useCallback((alertId) => {
        const reports = suspiciousBetting.map(r => {
            const receivers = r.receivers?.length ? r.receivers : []
            const report = {
                reportID: r.reportID,
                reportTitle: r.title,
                regulators: receivers.filter(r => r.role === "regulator").map(r => r.name).join(';'),
                sportGoverningBody: receivers.filter(r => r.role === "governingbody").map(r => r.name).join(';')
            }
            return report;
        })
        const downloadedFilename = analystChartTitles[graphType]?.fileName + `_${alertId}`;
        const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: downloadedFilename });
        const csv = generateCsv(csvConfig)(reports);
        download(csvConfig)(csv)
    }, [suspiciousBetting])

    useEffect(() => {
        if (isDetailScreen && exportVisible) {
            downloadHandler(alertId);
            setExportModalHandler(false);
        }
    }, [isDetailScreen, exportVisible, downloadHandler, setExportModalHandler, alertId]);
    const items = [
        {
            label: 'View',
            icon: 'pi pi-eye',
            disabled: !suspiciousBetting?.length,
            command: () => goToAnalyticsDetails(graphType)
        },
        {
            label: 'Export',
            icon: 'pi pi-upload',
            disabled: !isExport ? true : !suspiciousBetting?.length,
            command: () => downloadHandler(alertID)
        }
    ];
    const goToAnalyticsDetails = (type) => {
        navigate("/my-analytics-details?type=" + type, { state: { graphType, alertID } });
    }
    return (
        <div className="info-box">
            {!isDetailScreen && <>
                <div className="flex align-items-start justify-content-between gap-2">
                    <div className='pr-0'>
                        <h4>{analystChartTitles[graphType]?.title}</h4>
                        <p>{analystChartTitles[graphType]?.description}</p>
                    </div>
                </div>

                <div className="flex align-items-center justify-content-between gap-3 mt-2 p-input-icon-right">
                    <span className="p-input-icon-left w-12">
                        <i className="pi pi-search"></i>
                        <form onSubmit={searchHandler}>
                            <PR.InputText
                                id="alertLegacyId"
                                disabled={loading}
                                placeholder="Enter Alert-ID"
                                className="search-box"
                                value={searchAlertId}
                                autoComplete="off"
                                onChange={(event) => {
                                     inputSearchHandler(event, setSearchAlertId)
                                }}
                            />
                        </form>
                       {error && <p className="error-message mt-1 absolute">{error}</p>}
                       {noRecordsFound && <p className="error-message mt-1 absolute">{'No results found'}</p>}
                    </span>
                       <span className="right-clear-icon-suspicious">
                            {!!searchAlertId && <i style={{ cursor: 'pointer', color:"#6c757d" }} onClick={() => {inputSearchHandler({ target: { value: "" } }, setSearchAlertId);}} className="pi pi-times text-sm mr-2" />}
                        </span>
                    <div>
                        <PR.Menu model={items} popup ref={menuRight} id="popup_menu_right" className="export-popup" popupAlignment="right" />
                        <PR.Button icon="pi pi-ellipsis-v" className="export-button" onClick={(event) => menuRight.current.toggle(event)} aria-controls="popup_menu_right" aria-haspopup />
                    </div>

                </div>
            </>}
            {suspiciousBetting?.map((s, index) => (
                <div className="fixed-height" key={index}>
                    <div className="betting-report-block">
                        <h3>{s.title}</h3>
                        <div className="box">
                            <div className="box-header">
                                <p>Regulators</p>
                            </div>
                            <div className="box-body">
                                {s.receivers?.some(r => r.role === 'regulator') ? (
                                    s.receivers
                                        .filter(r => r.role === 'regulator')
                                        .map((r, i) => (
                                            <div className="reg-name" key={i}>
                                                {r.name}
                                            </div>
                                        ))
                                ) : (
                                    <p className="nodataFound">No regulators found for this alert</p>
                                )}
                            </div>
                        </div>
                        <div className="box">
                            <div className="box-header">
                                <p>Sport Governing Body</p>
                            </div>
                            <div className="box-body sgb">
                                {s.receivers?.some(r => r.role === 'governingbody') ? (
                                    s.receivers
                                        .filter(g => g.role === 'governingbody')
                                        .map((g, j) => (
                                            <div className="reg-name" key={j}>
                                                {g.name}
                                            </div>
                                        ))
                                ) : (
                                    <p className="nodataFound">No sport governing bodies found for this alert</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )

}
export default SuspiciousReport;